import styled from 'styled-components';

export type DiagnosisClassificationLayout = 'compact' | 'labeled';

interface LayoutProps {
  $layout: DiagnosisClassificationLayout;
}

const COMPACT_SELECT = 'w-full h-7 rounded-md border border-input bg-card px-2 text-xs';

export const FieldLabel = styled.label.attrs<LayoutProps & { $narrow?: boolean }>(
  ({ $layout, $narrow }) => ({
    className:
      $layout === 'compact'
        ? `${$narrow ? 'w-12' : 'w-14'} shrink-0 text-[11px] text-muted-foreground`
        : 'flex flex-col gap-1 text-xs font-medium text-muted-foreground',
  })
)<LayoutProps & { $narrow?: boolean }>``;

export const FieldLabelText = styled.span.attrs<LayoutProps>(({ $layout }) => ({
  className: $layout === 'compact' ? 'sr-only' : '',
}))<LayoutProps>``;

export const ClassificationSelect = styled.select.attrs<LayoutProps>(({ $layout }) => ({
  className:
    $layout === 'compact'
      ? COMPACT_SELECT
      : 'w-20 rounded-md border border-input bg-background px-2 py-1 text-xs',
}))<LayoutProps>``;

export const SeiteSelect = styled.select.attrs<LayoutProps>(({ $layout }) => ({
  className:
    $layout === 'compact'
      ? COMPACT_SELECT
      : 'w-16 rounded-md border border-gray-300 bg-white px-2 py-1 text-xs',
}))<LayoutProps>``;
